/**
 * Valtio store utilities for the Gibi app.
 */

/**
 * Reset a proxy to its initial state by assigning each key from the defaults.
 * This mutates the proxy in-place so Valtio picks up all changes.
 */
export function resetProxy<T extends object>(proxyObj: T, defaults: T): void {
    const keys = Object.keys(defaults) as (keyof T)[]
    for (const key of keys) {
        proxyObj[key] = defaults[key]
    }
}

/**
 * Helper type to strip Valtio's readonly snapshot wrapper when passing to
 * existing interfaces that expect mutable types.
 */
export type Mutable<T> = { -readonly [K in keyof T]: T[K] }

/**
 * Cast a Valtio snapshot value back to its mutable type.
 * Use when passing snapshot data to functions/components that expect mutable types.
 */
export function mutable<T>(val: T): Mutable<T> {
    return val as Mutable<T>
}
